import React, { useState } from 'react';

export default function App() {
  const [page, setPage] = useState('login');
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [loginInput, setLoginInput] = useState({ identifier: '', password: '' });
  const [formData, setFormData] = useState({
    fullName: '',
    username: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
  });

  const [errorMessage, setErrorMessage] = useState('');
  const [copied, setCopied] = useState(false);
  const ussdCode = "*182*1*1*0792497531#";

  const handleRegisterChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLoginChange = (e) => {
    setLoginInput({ ...loginInput, [e.target.name]: e.target.value });
  };

  const handleSignIn = (e) => {
    e.preventDefault();
    setErrorMessage('');

    const userExists = registeredUsers.find(
      (user) =>
        (user.email === loginInput.identifier ||
         user.username === loginInput.identifier ||
         user.fullName === loginInput.identifier) &&
        user.password === loginInput.password
    );

    if (userExists) {
      setPage('activation');
    } else {
      setErrorMessage("Account not found! Please create an account first.");
    }
  };

  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (formData.password !== formData.confirmPassword) {
      setErrorMessage("Passwords do not match!");
      return;
    }

    setRegisteredUsers([...registeredUsers, formData]);
    setPage('registered_success');
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(ussdCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handlePayNow = () => {
    navigator.clipboard.writeText(ussdCode);
    setCopied(true);
    window.location.href = `tel:${encodeURIComponent(ussdCode)}`;
  };

  return (
    <div className="min-h-screen bg-[#0d1424] text-white flex items-center justify-center p-4 font-sans">
      <div className="w-full max-w-md bg-[#162032]/80 backdrop-blur-md rounded-2xl border border-slate-800 p-8 shadow-2xl">
        
        {/* LOGO HEADER */}
        <div className="flex flex-col items-center mb-6">
          <div className="w-14 h-14 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-500/30 mb-3">
            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold tracking-wide">Travolium</h1>
          <p className="text-sm text-slate-400 mt-1">Invest & Earn Rewards</p>
        </div>

        {/* 1. SIGN IN PAGE */}
        {page === 'login' && (
          <form onSubmit={handleSignIn} className="space-y-4">
            {errorMessage && (
              <div className="bg-red-500/20 border border-red-500/50 text-red-300 text-xs p-3 rounded-xl text-center">
                {errorMessage}
              </div>
            )}

            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-2">Full Name or Email</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400">👤</span>
                <input
                  type="text"
                  name="identifier"
                  required
                  placeholder="John Doe or you@example.com"
                  onChange={handleLoginChange}
                  className="w-full pl-10 pr-4 py-3 bg-[#1e293b]/50 border border-slate-700/60 rounded-xl text-sm focus:outline-none focus:border-blue-500 text-slate-200 placeholder-slate-500"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-2">Password</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400">🔒</span>
                <input
                  type="password"
                  name="password"
                  required
                  placeholder="Enter your password"
                  onChange={handleLoginChange}
                  className="w-full pl-10 pr-10 py-3 bg-[#1e293b]/50 border border-slate-700/60 rounded-xl text-sm focus:outline-none focus:border-blue-500 text-slate-200 placeholder-slate-500"
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full mt-2 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-medium rounded-xl transition duration-200 flex items-center justify-center gap-2 shadow-lg shadow-indigo-500/25"
            >
              Sign In ➔
            </button>

            <p className="text-center text-xs text-slate-400 mt-4">
              Don't have an account?{' '}
              <button
                type="button"
                onClick={() => { setErrorMessage(''); setPage('register'); }}
                className="text-blue-400 hover:underline font-medium"
              >
                Create Account
              </button>
            </p>
          </form>
        )}

        {/* 2. CREATE ACCOUNT PAGE */}
        {page === 'register' && (
          <form onSubmit={handleRegisterSubmit} className="space-y-3">
            {errorMessage && (
              <div className="bg-red-500/20 border border-red-500/50 text-red-300 text-xs p-2.5 rounded-xl text-center">
                {errorMessage}
              </div>
            )}

            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">Full Name</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400 text-xs">👤</span>
                <input
                  type="text"
                  name="fullName"
                  required
                  placeholder="John Doe"
                  onChange={handleRegisterChange}
                  className="w-full pl-9 pr-3 py-2.5 bg-[#1e293b]/50 border border-slate-700/60 rounded-xl text-xs focus:outline-none focus:border-blue-500 text-slate-200"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">Username</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400 text-xs">@</span>
                <input
                  type="text"
                  name="username"
                  required
                  placeholder="johndoe"
                  onChange={handleRegisterChange}
                  className="w-full pl-9 pr-3 py-2.5 bg-[#1e293b]/50 border border-slate-700/60 rounded-xl text-xs focus:outline-none focus:border-blue-500 text-slate-200"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">Email Address</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400 text-xs">✉️</span>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="you@example.com"
                  onChange={handleRegisterChange}
                  className="w-full pl-9 pr-3 py-2.5 bg-[#1e293b]/50 border border-slate-700/60 rounded-xl text-xs focus:outline-none focus:border-blue-500 text-slate-200"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">Phone Number</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400 text-xs">📞</span>
                <input
                  type="tel"
                  name="phone"
                  required
                  placeholder="+250 7XX XXX XXX"
                  onChange={handleRegisterChange}
                  className="w-full pl-9 pr-3 py-2.5 bg-[#1e293b]/50 border border-slate-700/60 rounded-xl text-xs focus:outline-none focus:border-blue-500 text-slate-200"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">Password</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400 text-xs">🔒</span>
                <input
                  type="password"
                  name="password"
                  required
                  placeholder="Min. 6 characters"
                  onChange={handleRegisterChange}
                  className="w-full pl-9 pr-8 py-2.5 bg-[#1e293b]/50 border border-slate-700/60 rounded-xl text-xs focus:outline-none focus:border-blue-500 text-slate-200"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">Confirm Password</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400 text-xs">🔒</span>
                <input
                  type="password"
                  name="confirmPassword"
                  required
                  placeholder="Confirm your password"
                  onChange={handleRegisterChange}
                  className="w-full pl-9 pr-3 py-2.5 bg-[#1e293b]/50 border border-slate-700/60 rounded-xl text-xs focus:outline-none focus:border-blue-500 text-slate-200"
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full mt-3 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-medium rounded-xl transition duration-200 flex items-center justify-center gap-2 shadow-lg shadow-blue-500/25 text-xs"
            >
              Create Account ➔
            </button>

            <p className="text-center text-xs text-slate-400 mt-2">
              Already have an account?{' '}
              <button
                type="button"
                onClick={() => { setErrorMessage(''); setPage('login'); }}
                className="text-blue-400 hover:underline font-medium"
              >
                Sign In
              </button>
            </p>
          </form>
        )}

        {/* 2.1 REGISTER SUCCESS PAGE */}
        {page === 'registered_success' && (
          <div className="text-center space-y-4 py-4">
            <div className="w-16 h-16 bg-emerald-500/20 text-emerald-400 rounded-full flex items-center justify-center mx-auto text-3xl animate-bounce">
              ✓
            </div>
            <h2 className="text-xl font-bold text-white">Account Created Successfully!</h2>
            <p className="text-xs text-slate-300 leading-relaxed px-2">
              Welcome to Travolium. Your account has been registered. Please proceed to activate your account to unlock all features.
            </p>
            <button
              type="button"
              onClick={() => setPage('activation')}
              className="w-full py-3 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white font-medium rounded-xl transition duration-200 flex items-center justify-center gap-2 text-xs shadow-lg shadow-emerald-500/25 mt-4"
            >
              Continue to Activation ➔
            </button>
          </div>
        )}

        {/* 3. ACCOUNT ACTIVATION PAGE */}
        {page === 'activation' && (
          <div className="space-y-4">
            <div className="text-center mb-4">
              <h2 className="text-xl font-bold">Account Activation</h2>
              <p className="text-xs text-slate-400 mt-1">Activate your account to unlock all features</p>
            </div>

            <div className="bg-[#1e293b]/40 border border-slate-800 rounded-xl p-4 flex items-start gap-3">
              <span className="text-lg">💳</span>
              <p className="text-xs text-slate-300 leading-relaxed">
                To activate your account, please send the activation fee of <strong className="text-white font-semibold">3,800 FRW</strong> using the USSD code below
              </p>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-400 mb-2">USSD Code</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  readOnly
                  value={ussdCode}
                  className="w-full bg-[#1e293b]/80 border border-slate-700 rounded-xl px-3 py-2.5 text-xs text-blue-400 font-mono font-semibold"
                />
                <button
                  type="button"
                  onClick={handleCopy}
                  className="bg-[#1e293b] border border-slate-700 hover:bg-slate-800 text-slate-300 px-3 py-2.5 rounded-xl text-xs font-medium transition flex items-center gap-1"
                >
                  {copied ? <span className="text-emerald-400">✓ Copied</span> : '📋 Copy'}
                </button>
              </div>
            </div>

            <button
              type="button"
              onClick={handlePayNow}
              className="w-full py-3 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-medium rounded-xl transition duration-200 flex items-center justify-center gap-2 text-xs shadow-lg shadow-blue-500/20"
            >
              📞 Pay Now ➔
            </button>

            <div className="bg-[#1e293b]/30 border border-slate-800 rounded-xl p-3 flex items-start gap-2.5">
              <span className="text-xs mt-0.5">⏱️</span>
              <p className="text-[11px] text-slate-400 leading-relaxed">
                Our team manually verifies all activation requests within <strong className="text-slate-200">1-2 hours</strong>. You will receive a notification when your account is active.
              </p>
            </div>

            <button
              type="button"
              onClick={() => alert("Checking status...")}
              className="w-full py-2.5 bg-[#1e293b]/60 border border-slate-700/50 hover:bg-[#1e293b] text-slate-300 text-xs font-medium rounded-xl transition flex items-center justify-center gap-2"
            >
              🔄 Refresh Status
            </button>
            
            <div className="text-center mt-2">
              <button 
                onClick={() => { setErrorMessage(''); setPage('login'); }} 
                className="text-[11px] text-slate-500 hover:text-slate-300 transition"
              >
                ← Back to Login
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}